/**
 * SOULGASM INTERACTIVE FUNCTIONALITY
 * Handles Mantra Audio Player, Variant Selectors, and Accordions
 */

document.addEventListener('DOMContentLoaded', () => {

  // --- MANTRA AUDIO PLAYER LOGIC ---
  const setupMantraAudioPlayer = (container) => {
    if (!container || container.dataset.playerInitialized === 'true') return;
    container.dataset.playerInitialized = 'true';

    const toggleBtn = container.querySelector('.mantra-audio-play-btn');
    const timeEl = container.querySelector('.mantra-audio-time');
    const barTrack = container.querySelector('.mantra-audio-bar');
    const barFill = container.querySelector('.mantra-audio-bar-fill');
    let audio = container.querySelector('audio.mantra-html5-audio');

    const audioSrc = container.getAttribute('data-audio-src');
    if (!audio && audioSrc) {
      audio = new Audio(audioSrc);
      audio.preload = 'metadata';
      container.appendChild(audio);
    }
    if (!audio || !toggleBtn || !barTrack || !barFill) return;

    const playIcon = toggleBtn.querySelector('.play-icon');
    const pauseIcon = toggleBtn.querySelector('.pause-icon');

    const formatTime = (secs) => {
      if (isNaN(secs) || secs < 0) return '0:00';
      const m = Math.floor(secs / 60);
      const s = Math.floor(secs % 60);
      return `${m}:${s < 10 ? '0' : ''}${s}`;
    };

    const updateDisplay = () => {
      const cur = audio.currentTime || 0;
      const dur = audio.duration || 0;
      if (timeEl) {
        timeEl.textContent = `${formatTime(cur)} / ${dur > 0 ? formatTime(dur) : '0:00'}`;
      }
      if (dur > 0) {
        const pct = Math.min(100, Math.max(0, (cur / dur) * 100));
        barFill.style.width = `${pct}%`;
      } else {
        barFill.style.width = '0%';
      }
    };

    audio.addEventListener('loadedmetadata', updateDisplay);
    audio.addEventListener('timeupdate', updateDisplay);

    audio.addEventListener('play', () => {
      // Pause any other playing audio on the page
      document.querySelectorAll('audio').forEach(otherAudio => {
        if (otherAudio !== audio && !otherAudio.paused) {
          otherAudio.pause();
        }
      });
      if (playIcon) playIcon.style.display = 'none';
      if (pauseIcon) pauseIcon.style.display = 'block';
    });

    audio.addEventListener('pause', () => {
      if (playIcon) playIcon.style.display = 'block';
      if (pauseIcon) pauseIcon.style.display = 'none';
    });

    audio.addEventListener('ended', () => {
      if (playIcon) playIcon.style.display = 'block';
      if (pauseIcon) pauseIcon.style.display = 'none';
      audio.currentTime = 0;
      updateDisplay();
    });

    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (audio.paused) {
        audio.play().catch(err => console.log('Audio play error:', err));
      } else {
        audio.pause();
      }
    });

    barTrack.addEventListener('click', (e) => {
      const rect = barTrack.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const pct = Math.max(0, Math.min(1, clickX / rect.width));
      if (audio.duration && !isNaN(audio.duration)) {
        audio.currentTime = pct * audio.duration;
        updateDisplay();
      }
    });

    updateDisplay();
  };

  // Initialize all Mantra Audio Players across the DOM
  document.querySelectorAll('.mantra-audio-player').forEach(setupMantraAudioPlayer);

  // --- HERO SACRED RITUAL VIDEO PLAYER LOGIC ---
  const heroVideoWrap = document.getElementById('heroVideoWrap') || document.querySelector('.hero-video-player-wrap');
  if (heroVideoWrap) {
    const heroVideo = heroVideoWrap.querySelector('video') || document.getElementById('heroVideo');
    const playBtn = heroVideoWrap.querySelector('.hero-video-play-btn') || document.getElementById('heroVideoPlayBtn');

    if (heroVideo) {
      const toggleVideoPlay = () => {
        if (heroVideo.paused) {
          heroVideo.play().catch(err => console.log('Video play error:', err));
        } else {
          heroVideo.pause();
        }
      };

      if (playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleVideoPlay();
        });
      }

      heroVideoWrap.addEventListener('click', (e) => {
        // If clicking on native video controls, don't interfere
        if (e.target === heroVideo && heroVideo.hasAttribute('controls') && !heroVideo.paused) {
          return;
        }
        toggleVideoPlay();
      });

      heroVideo.addEventListener('play', () => {
        heroVideoWrap.classList.add('is-playing');
        heroVideo.setAttribute('controls', 'true');
      });

      heroVideo.addEventListener('pause', () => {
        heroVideoWrap.classList.remove('is-playing');
      });

      heroVideo.addEventListener('ended', () => {
        heroVideoWrap.classList.remove('is-playing');
        heroVideo.removeAttribute('controls');
        heroVideo.load();
      });
    }
  }


  // --- VARIANT SELECTION LOGIC is handled by component sections (product-hero.liquid) ---


  // --- RANDOMIZED BACKGROUND GRAPHICS LOGIC ---
  const siteGraphics = [
    '01_crescent_foliage.png',
    '02_crescent_simple.png',
    '03_crescent_starry.png',
    '04_crescent_glow.png',
    '05_star_cluster_small.png',
    '06_star_cross_pair.png',
    '11_hanging_stars.png',
    '12_sun_radiant.png',
    '13_sun_face.png',
    '14_sunburst_round.png',
    '16_compass_rose.png',
    '17_spiral_galaxy.png',
    '20_flower_of_life.png',
    '21_sacred_geometry_hex.png',
    '22_zodiac_circle.png',
    '24_mystical_eye.png',
    '27_moon_symbol.png',
    '29_olive_branch_large.png',
    '30_olive_branch_small_left.png',
    '31_olive_branch_small_right.png',
    '33_lavender_sprig.png',
    '34_wildflower_tall.png',
    '35_daisy_bloom.png',
    '40_amphora.png',
    '42_ionic_column.png',
    '46_crystal_branch.png',
    '51_sun_rays_bottom.png',
    '53_floral_flourish.png'
  ];

  const initRandomBackgroundGraphics = () => {
    const pageWrapper = document.querySelector('.page-wrapper') || document.body;
    if (!pageWrapper) return;

    let container = document.querySelector('.bg-floating-graphics-container');
    if (!container) {
      container = document.createElement('div');
      container.className = 'bg-floating-graphics-container';
      if (pageWrapper.firstChild) {
        pageWrapper.insertBefore(container, pageWrapper.firstChild);
      } else {
        pageWrapper.appendChild(container);
      }
    } else {
      container.innerHTML = '';
    }

    const mainContent = document.getElementById('MainContent') || document.querySelector('.main-content') || pageWrapper;

    // Identify PDP exclusion zones (product photo and centered details block)
    const heroEl = document.querySelector('.product-hero');
    const heroBottom = heroEl ? (heroEl.offsetTop + heroEl.offsetHeight) : 0;

    const descEl = document.querySelector('.pdp-description-block') || document.querySelector('.pdp-centered-details-wrap');
    let descTop = 0;
    let descBottom = 0;
    if (descEl) {
      descTop = descEl.offsetTop - 50;
      descBottom = descEl.offsetTop + descEl.offsetHeight + 50;
    }

    // Identify Search Form exclusion zone (header + search bar)
    const searchForm = document.querySelector('.search-form-wrap') || document.querySelector('.search-title');
    let searchFormTop = 0;
    let searchFormBottom = 0;
    if (searchForm) {
      searchFormTop = 0;
      searchFormBottom = searchForm.offsetTop + searchForm.offsetHeight + 60;
    }

    // Collect top-level distinct section elements without duplicates or child overlaps
    const majorSelectors = [
      '.home-hero-section',
      '.category-torn-box',
      '#daily-tarot',
      '.home-about-section-clean',
      '.home-about-section',
      '.home-newsletter-section',
      '.collection-page-section',
      '.search-page-section',
      '.product-hero',
      '#mantra-section',
      '.section-usage-care',
      '.related-products-section',
      '.contact-section',
      '.ceremony-page-container',
      '.guide-page-container',
      '.mailing-page-container',
      '.page-container-section'
    ];

    let sections = Array.from(document.querySelectorAll(majorSelectors.join(', ')));

    // If template has generic sections, get direct children of MainContent
    if (sections.length === 0) {
      sections = Array.from(mainContent.children).filter(el => {
        return el.offsetHeight > 100 && el !== container;
      });
    }

    // Filter out any nested descendants so each area is only evaluated once
    sections = sections.filter((sec, idx) => {
      return !sections.some((other, oIdx) => oIdx !== idx && other.contains(sec));
    });

    if (sections.length === 0) return;

    const leftXPositions = [3, 5, 4, 6, 2, 5];
    const rightXPositions = [88, 91, 89, 92, 87, 90];
    const shuffled = [...siteGraphics].sort(() => 0.5 - Math.random());
    let graphicIdx = 0;
    let isLeft = true;
    let lastLeftTop = -999;
    let lastRightTop = -999;
    const minSpacing = 280; // Balanced vertical spacing between objects on the same side

    sections.forEach((sec) => {
      const secTop = sec.offsetTop;
      const secHeight = Math.max(sec.offsetHeight, 350);

      // On homepage hero: 2 well-spaced atmospheric graphics
      const isHero = sec.classList.contains('home-hero-section');
      const count = isHero ? 2 : Math.max(1, Math.min(3, Math.round(secHeight / 380)));
      const step = secHeight / (count + 1);

      for (let i = 1; i <= count; i++) {
        let topPx = Math.round(secTop + (i * step));

        // Skip PDP hero and description reading areas
        if (heroBottom && topPx <= heroBottom) continue;
        if (descTop && topPx >= descTop && topPx <= descBottom) continue;

        // Skip Search Form area (top of search page)
        if (searchFormBottom && topPx >= searchFormTop && topPx <= searchFormBottom) {
          topPx = searchFormBottom + 40;
        }

        // Ensure proper vertical breathing room between objects
        const lastTop = isLeft ? lastLeftTop : lastRightTop;
        if (topPx - lastTop < minSpacing) {
          topPx = lastTop + minSpacing;
          if (topPx > secTop + secHeight + 80) continue;
        }

        const leftPct = isLeft
          ? leftXPositions[graphicIdx % leftXPositions.length]
          : rightXPositions[graphicIdx % rightXPositions.length];

        if (isLeft) {
          lastLeftTop = topPx;
        } else {
          lastRightTop = topPx;
        }
        isLeft = !isLeft;

        const fileName = shuffled[graphicIdx % shuffled.length];
        graphicIdx++;

        const img = document.createElement('img');
        const baseUrl = window.SOULGASM_GRAPHICS_URL || 'assets/isolated_site_graphics/';
        img.src = `${baseUrl}${fileName}`;
        img.className = 'bg-floating-graphic';
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');

        const rot = Math.floor(Math.random() * 40 - 20);
        const opacity = (0.40 + Math.random() * 0.25).toFixed(2); // Subtle 0.40 to 0.65
        const scale = (0.75 + Math.random() * 0.25).toFixed(2); // 0.75 to 1.00

        img.style.top = `${topPx}px`;
        img.style.left = `${leftPct}%`;
        img.style.transform = `scale(${scale}) rotate(${rot}deg)`;
        img.style.setProperty('--rot', `${rot}deg`);
        img.style.opacity = opacity;

        container.appendChild(img);
      }
    });
  };

  initRandomBackgroundGraphics();
  window.addEventListener('load', initRandomBackgroundGraphics);

  // --- 2-TAB USAGE & CARE MODULE LOGIC ---
  const usageTabBtns = document.querySelectorAll('.usage-tab-btn');
  const usagePanels = document.querySelectorAll('.usage-tab-panel');

  usageTabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = btn.getAttribute('data-tab');
      
      usageTabBtns.forEach(b => b.classList.remove('active'));
      usagePanels.forEach(p => p.classList.remove('active'));

      btn.classList.add('active');
      const targetPanel = document.getElementById(`tab-panel-${tabId}`);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });
  });

  const readMoreBtns = document.querySelectorAll('.usage-read-more-btn');
  readMoreBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const parentPanel = btn.closest('.usage-tab-panel');
      const textClamp = parentPanel ? parentPanel.querySelector('.usage-text-clamp') : null;
      if (!textClamp) return;

      const isCollapsed = textClamp.classList.contains('collapsed');
      if (isCollapsed) {
        textClamp.classList.remove('collapsed');
        btn.querySelector('span').textContent = 'Read Less';
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('expanded');
      } else {
        textClamp.classList.add('collapsed');
        btn.querySelector('span').textContent = 'Read More';
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('expanded');
      }
    });
  });

});
